(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gymgrl-scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function() {
  function initGR() {
    if (!window.IntersectionObserver) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var EASE = 'cubic-bezier(0.22,1,0.36,1)';
    var DUR = 700;
    var STAGGER = 100;
    var done = new WeakSet();

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.style.opacity = '1';
        el.style.transform = 'none';
        observer.unobserve(el);
      });
    }, { rootMargin: '0px 0px -72px 0px', threshold: 0 });

    function addReveal(el, delay) {
      if (!el || done.has(el)) return;
      done.add(el);
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(48px)';
      el.style.transition =
        'opacity ' + DUR + 'ms ' + EASE + ' ' + delay + 'ms,' +
        'transform ' + DUR + 'ms ' + EASE + ' ' + delay + 'ms';
      observer.observe(el);
    }

    /* ── Section-level blocks: each animates in as one unit ─────────────── */
    var singles = [
      '.ghmq',            /* marquee bar */
      '.ghst__inner',     /* statement: both cols together */
      '.ghpd__inner',     /* home product: image + content */
      '.ghqt__inner',     /* pull quote */
      '.ghct__inner',     /* home CTA */
      '.gst__inner',      /* science teaser */
      '.gis__intro',      /* ingredients science header */
      '.gis__support-wrap', /* ingredients support grid wrapper */
      '.gpq__inner',      /* press quote */
      '.gtb',             /* trust bar */
      '.grt__header',     /* results timeline section header */
      '.grt__row',        /* each timeline row independently */
      '.ghtu__header',    /* how-to-use section header */
      '.gcc__wrap'        /* editorial carousel */
    ];

    /* ── Grid/card groups: direct children stagger in sequence ──────────── */
    var staggerParents = [
      '.ghrv__header',    /* reviews: eyebrow + title + stars stagger */
      '.ghrv__grid',      /* review cards */
      '.ghpl__header',    /* pillars: eyebrow + title stagger */
      '.ghpl__grid',      /* pillar image cards */
      '.gbi__head',       /* benefit icons: eyebrow + title */
      '.gbi__grid',       /* benefit icon cards */
      '.ghtu__steps',     /* how-to-use steps */
      '.gug__head',       /* UGC: title + subtitle */
      '.gug__grid',       /* UGC video items */
      '.gtm__header',     /* testimonials: eyebrow + title */
      '.gtm__grid',       /* testimonial cards */
      '.gis__heroes',     /* ingredient hero cards */
      '.gcc__header'      /* carousel: title + nav arrows */
    ];

    singles.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        addReveal(el, 0);
      });
    });

    staggerParents.forEach(function(parentSel) {
      document.querySelectorAll(parentSel).forEach(function(parent) {
        Array.from(parent.children).forEach(function(child, i) {
          addReveal(child, i * STAGGER);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGR);
  } else {
    initGR();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
